import { CheckCircle } from 'lucide-react'

export default function InvoicePaid() {
    return (
            <div className="w-full bg-white rounded-lg shadow-sm p-8 text-center">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                    <CheckCircle className="h-8 w-8 text-green-600" />
                </div>
                <h1 className="text-2xl font-semibold text-gray-900 mb-2">Payment Successful!</h1>
                <p className="text-gray-600 mb-6">
                    Your invoice has been paid successfully.
                </p>
            </div>
    )
}